// collection-hierarchy.js
// MEN (full + Gym Shoes) + WOMEN (Football, Casual, Running) + KIDS (Football)
// Defines the structure: Main Category → Brand → Type
//
// Types can be:
//   { handle: "..." } → links to a separate collection
//   { tag: "..." }    → filters the current collection by tag (no new collection needed)
//
// Types can ALSO live directly under a category (no brand level) — used for Gym Shoes.

window.CollectionHierarchy = {

  // ============ MEN ============
  men: {

    "all-football-cleats": {
      title: "Football Shoes",
      image: null,
      brands: {
        "nike-football-shoes": {
          title: "Nike",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: [
            { handle: "nike-turef", title: "Turf Cleats" },
            { handle: "nike-shoes-with-studs", title: "Cleats with Studs" },
            { handle: "nike-predator", title: "Phantom" },
            { handle: "nike-tempo", title: "Tiempo" },
            { handle: "nike-metalic-studs", title: "Metallic Studs" }
          ]
        },
        "adidas-football-shoes": {
          title: "Adidas",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
          types: [
            { handle: "addidas-shoes-with-studs", title: "Cleats with Studs" },
            { handle: "addidas-turf-shoes", title: "Turf" },
            { handle: "adidas-predator", title: "Predator" },
            { handle: "adidas-matelic-studs", title: "Metallic Studs" },
            { tag: "Adidas F50", title: "F50" }
          ]
        },
        "pumaa": {
          title: "Puma",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/puma-logo.svg?v=1779282038",
          types: []
        }
      }
    },

    "futsal-shoes": {
      title: "Futsal Cleats",
      image: null,
      brands: {
        "nike-futsal": { title: "Nike", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577", types: [] },
        "adidas-futsal": { title: "Adidas", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123", types: [] },
        "joma-futsal-1": { title: "Joma", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/joma.png?v=1779386656", types: [] }
      }
    },

    "runing-and-casual-shoes": {
      title: "Running Shoes",
      image: null,
      brands: {
        "nike-runing-shoes-1": {
          title: "Nike",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: [
            { handle: "nike-alpha-fly", title: "Alphafly" },
            { handle: "spikes-running-shoes", title: "Spikes" }
          ]
        },
        "a": {
          title: "Adidas",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
          types: [
            { tag: "Adidas Running Shoes HyperBoost", title: "HyperBoost" },
            { tag: "Adidas adizero", title: "Adizero" },
            { tag: "ADIZERO BOSTON", title: "Adizero Boston" }
          ]
        },
        "hoka-running-shoes": { title: "Hoka", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/hoka.png?v=1779386664", types: [] },
        "new-balance-running-shoes-1": { title: "New Balance", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/newbalnce.png?v=1779386719", types: [] },
        "saucony-running-shoes": { title: "Saucony", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/saucony-2.svg?v=1779282317", types: [] },
        "brooks": { title: "Brooks", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brooks-3.svg?v=1779282385", types: [] },
        "asics-running": { title: "ASICS", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225", types: [] },
        "on-cloud-running-shoes": {
          title: "On Cloud",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/oncloud.png?v=1779386709",
          types: [
            { handle: "water-proof-shoes", title: "Waterproof" }
          ]
        },
        "north-face": { title: "North Face", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/north.png?v=1779386701", types: [] }
      }
    },

    "gym-shoes": {
      title: "Gym Shoes",
      image: null,
      types: [
        { tag: "Nike Pegasus", title: "Nike Pegasus" },
        { tag: "Nike Vomero", title: "Nike Vomero" },
        { tag: "ultraboost", title: "Adidas Ultraboost" },
        { handle: "adidas-hyperboost", title: "Adidas HyperBoost" },
        { tag: "Asics NovaBlast", title: "Asics Novablast" }
      ]
    },

    "padle-shoes": {
      title: "Padel Shoes",
      image: null,
      brands: {
        "on-cloud-padel-shoes": { title: "On Cloud", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/padel.jpg?v=1779386674", types: [] },
        "asics-padel-shoes": { title: "ASICS", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225", types: [] }
      }
    },

    // "basketball-shoes": {
    //   title: "Basketball"
    // },

    "casual-shoes": {
      title: "Casual Shoes",
      image: null,
      brands: {
        "casual-shoes-general": { title: "General", image: null, types: [] },
        "alexander-mcqueen-casual-shoes": { title: "Alexander McQueen", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/alexnder.jpg?v=1779386690", types: [] },
        "new-balance-casual-shoes": { title: "New Balance", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/newbalnce.png?v=1779386719", types: [] },
        "adidas-casual-shoes": { title: "Adidas", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123", types: [] },
        "nike-casual-shoes": { title: "Nike Mind", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike.png?v=1779386648", types: [] },
        "armani-shoes" :{ title:"Armani Shoes", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/armani.jpg?v=1789576160", types: [] }
      }
    },

    "sports-wear-accesories": {
      title: "Accessories",
      image: null,
      brands: {
        "shin-guard": { title: "Shin Guards", image: null, types: [] },
        "goalkeeper-gloves": { title: "Goalkeeper Gloves", image: null, types: [] },
        "sport-water-bottles": { title: "Water Bottles", image: null, types: [] },
        "balls": { title: "Balls", image: null, types: [] },
        "shoes-bag": { title: "Shoe Bags", image: null, types: [] },
        "hoodies": { title: "Hoodies", image: null, types: [] },
        "winter-collection-football-jackets": { title: "Jackets", image: null, types: [] },
        "national-teams-shirt": { title: "National Teams", image: null, types: [] },
        "long-sleeve-football-shirts": { title: "Long Sleeve Shirts", image: null, types: [] },
        "fan-version": { title: "Fan Version", image: null, types: [] },
        "player-version": { title: "Player Version", image: null, types: [] }
      }
    }

  },

  // ============ WOMEN ============
  // Women's Gym Shoes will be added here when those collections are created.
  women: {

    "women-football-shoes": {
      title: "Football Shoes",
      image: null,
      brands: {
        "women-nike-football-shoes": {
          title: "Nike",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: [
            { tag: "nike phantom", title: "Phantom" },
            { tag: "nike tempo", title: "Tiempo" },
            { tag: "nike turf", title: "Turf" },
            { tag: "nike with studs", title: "Studs" },
            { tag: "NIKE PRO SHOES", title: "Pro" }
          ]
        },
        "women-adidas-football-shoes": {
          title: "Adidas",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
          types: [
            { tag: "adidas predator", title: "Predator" },
            { tag: "Adidas F50", title: "F50" },
            { tag: "adidas turf", title: "Turf" },
            { tag: "adidas with stud", title: "Studs" },
            { tag: "ADIDAS PRO SHOES", title: "Pro" }
          ]
        }
      }
    },

    "women-running-shoes": {
      title: "Running Shoes",
      image: null,
      brands: {
        "women-nike-running-shoes": {
          title: "Hoka",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: [
            { tag: "NIKE ALPHAFLY", title: "Alphafly" },
            { tag: "SPIKES", title: "Spikes" }
          ]
        },
        "women-nike-running-shoes": {
          title: "Nike",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: [
            { tag: "NIKE ALPHAFLY", title: "Alphafly" },
            { tag: "SPIKES", title: "Spikes" }
          ]
        },
         "women-adidas-running-shoes": {
          title: "Adidas",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
          types: []
        },
        "women-asics-running-shoes": {
          title: "ASICS",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225",
          types: []
        }
      }
    },

    "women-casual-shoes": {
      title: "Casual Shoes",
      image: null,
      brands: {
        "women-nike-casual-shoes": {
          title: "Nike",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: []
        },
        "women-adidas-casual-shoes": {
          title: "Adidas",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
          types: [
            { tag: "adidas gazelle", title: "Gazelle" },
            { tag: "ADIDAS CAMPUS", title: "Campus" },
            { tag: "adidas superstar", title: "Superstar" }
          ]
        },
        "women-new-balance-casual-shoes": {
          title: "New Balance",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/newbalnce.png?v=1779386719",
          types: []
        }
      }
    }

  },

  // ============ KIDS ============
  // Kids currently only has Football Shoes (Nike + Adidas).
  // NOTE: The category KEY "nike-kids-football-shoes" is used as both the category
  // handle AND the Nike brand handle. Since there's no dedicated "kids football parent"
  // collection, clicking the category pill (or landing on Nike Kids from anywhere)
  // resolves to /collections/nike-kids-football-shoes — a real, existing page.
  // The engine's findCollectionInHierarchy walks all keys (categories AND brands),
  // so /collections/adidas-football-shoes-1 will also correctly resolve to Kids > Football > Adidas.
  kids: {

    "kids-football-shoes": {
      title: "Football Shoes",
      image: null,
      brands: {
        "kids-football-shoes": {
          title: "Nike",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
          types: []
        },
        "adidas-football-shoes-1": {
          title: "Adidas",
          image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
          types: []
        }
      }
    }

  }

};
// // collection-hierarchy.js
// // MEN (full + Gym Shoes) + WOMEN (Football, Casual, Running)
// // Defines the structure: Main Category → Brand → Type
// //
// // Types can be:
// //   { handle: "..." } → links to a separate collection
// //   { tag: "..." }    → filters the current collection by tag (no new collection needed)
// //
// // Types can ALSO live directly under a category (no brand level) — used for Gym Shoes.

// window.CollectionHierarchy = {

//   // ============ MEN ============
//   men: {

//     "all-football-cleats": {
//       title: "Football Shoes",
//       image: null,
//       brands: {
//         "nike-football-shoes": {
//           title: "Nike",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
//           types: [
//             { handle: "nike-turef", title: "Turf Cleats" },
//             { handle: "nike-shoes-with-studs", title: "Cleats with Studs" },
//             { handle: "nike-predator", title: "Phantom" },
//             { handle: "nike-tempo", title: "Tiempo" },
//             { handle: "nike-metalic-studs", title: "Metallic Studs" }
//           ]
//         },
//         "adidas-football-shoes": {
//           title: "Adidas",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
//           types: [
//             { handle: "addidas-shoes-with-studs", title: "Cleats with Studs" },
//             { handle: "addidas-turf-shoes", title: "Turf" },
//             { handle: "adidas-predator", title: "Predator" },
//             { handle: "adidas-matelic-studs", title: "Metallic Studs" },
//             { tag: "Adidas F50", title: "F50" }
//           ]
//         },
//         "pumaa": {
//           title: "Puma",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/puma-logo.svg?v=1779282038",
//           types: []
//         }
//       }
//     },

//     "futsal-shoes": {
//       title: "Futsal Cleats",
//       image: null,
//       brands: {
//         "nike-futsal": { title: "Nike", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577", types: [] },
//         "adidas-futsal": { title: "Adidas", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123", types: [] },
//         "joma-futsal-1": { title: "Joma", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/joma.png?v=1779386656", types: [] }
//       }
//     },

//     "runing-and-casual-shoes": {
//       title: "Running Shoes",
//       image: null,
//       brands: {
//         "nike-runing-shoes-1": {
//           title: "Nike",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
//           types: [
//             { handle: "nike-alpha-fly", title: "Alphafly" },
//             { handle: "spikes-running-shoes", title: "Spikes" }
//           ]
//         },
//         "a": {
//           title: "Adidas",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
//           types: [
//             { tag: "Adidas Running Shoes HyperBoost", title: "HyperBoost" },
//             { tag: "Adidas adizero", title: "Adizero" },
//             { tag: "ADIZERO BOSTON", title: "Adizero Boston" }
//           ]
//         },
//         "hoka-running-shoes": { title: "Hoka", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/hoka.png?v=1779386664", types: [] },
//         "new-balance-running-shoes-1": { title: "New Balance", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/newbalnce.png?v=1779386719", types: [] },
//         "saucony-running-shoes": { title: "Saucony", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/saucony-2.svg?v=1779282317", types: [] },
//         "brooks": { title: "Brooks", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/brooks-3.svg?v=1779282385", types: [] },
//         "asics-running": { title: "ASICS", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225", types: [] },
//         "on-cloud-running-shoes": {
//           title: "On Cloud",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/oncloud.png?v=1779386709",
//           types: [
//             { handle: "water-proof-shoes", title: "Waterproof" }
//           ]
//         },
//         "north-face": { title: "North Face", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/north.png?v=1779386701", types: [] }
//       }
//     },

//     // ============ GYM SHOES (NEW) ============
//     // Single master collection 'gym-shoes' with model tags as direct types.
//     // No brand row — 5 model pills appear directly when the category is selected.
//     "gym-shoes": {
//       title: "Gym Shoes",
//       image: null,
//       types: [
//         { tag: "Nike Pegasus", title: "Nike Pegasus" },
//         { tag: "Nike Vomero", title: "Nike Vomero" },
//         { tag: "ultraboost", title: "Adidas Ultraboost" },
//         { handle: "adidas-hyperboost", title: "Adidas HyperBoost" },
//         { tag: "Asics NovaBlast", title: "Asics Novablast" }
//       ]
//     },

//     "padle-shoes": {
//       title: "Padel Shoes",
//       image: null,
//       brands: {
//         "on-cloud-padel-shoes": { title: "On Cloud", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/padel.jpg?v=1779386674", types: [] },
//         "asics-padel-shoes": { title: "ASICS", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225", types: [] }
//       }
//     },
    
//   "basketball-shoes": {
//       title: "Basketball"
//     },
//     "casual-shoes": {
//       title: "Casual Shoes",
//       image: null,
//       brands: {
//         "casual-shoes-general": { title: "General", image: null, types: [] },
//         "alexander-mcqueen-casual-shoes": { title: "Alexander McQueen", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/alexnder.jpg?v=1779386690", types: [] },
//         "new-balance-casual-shoes": { title: "New Balance", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/newbalnce.png?v=1779386719", types: [] },
//         "adidas-casual-shoes": { title: "Adidas", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123", types: [] },
//         "nike-casual-shoes": { title: "Nike Mind", image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike.png?v=1779386648", types: [] }
//       }
//     },

//     "sports-wear-accesories": {
//       title: "Accessories",
//       image: null,
//       brands: {
//         "shin-guard": { title: "Shin Guards", image: null, types: [] },
//         "goalkeeper-gloves": { title: "Goalkeeper Gloves", image: null, types: [] },
//         "sport-water-bottles": { title: "Water Bottles", image: null, types: [] },
//         "balls": { title: "Balls", image: null, types: [] },
//         "shoes-bag": { title: "Shoe Bags", image: null, types: [] },
//         "hoodies": { title: "Hoodies", image: null, types: [] },
//         "winter-collection-football-jackets": { title: "Jackets", image: null, types: [] },
//         "national-teams-shirt": { title: "National Teams", image: null, types: [] },
//         "long-sleeve-football-shirts": { title: "Long Sleeve Shirts", image: null, types: [] },
//         "fan-version": { title: "Fan Version", image: null, types: [] },
//         "player-version": { title: "Player Version", image: null, types: [] }
//       }
//     }

//   },

//   // ============ WOMEN ============
//   // Women's Gym Shoes will be added here when those collections are created.
//   women: {

//     "women-football-shoes": {
//       title: "Football Shoes",
//       image: null,
//       brands: {
//         "women-nike-football-shoes": {
//           title: "Nike",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
//           types: [
//             { tag: "nike phantom", title: "Phantom" },
//             { tag: "nike tempo", title: "Tiempo" },
//             { tag: "nike turf", title: "Turf" },
//             { tag: "nike with studs", title: "Studs" },
//             { tag: "NIKE PRO SHOES", title: "Pro" }
//           ]
//         },
//         "women-adidas-football-shoes": {
//           title: "Adidas",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
//           types: [
//             { tag: "adidas predator", title: "Predator" },
//             { tag: "Adidas F50", title: "F50" },
//             { tag: "adidas turf", title: "Turf" },
//             { tag: "adidas with stud", title: "Studs" },
//             { tag: "ADIDAS PRO SHOES", title: "Pro" }
//           ]
//         }
//       }
//     },

//     "women-running-shoes": {
//       title: "Running Shoes",
//       image: null,
//       brands: {
//         "women-nike-running-shoes": {
//           title: "Nike",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/nike_2025.webp?v=1779233577",
//           types: [
//             { tag: "NIKE ALPHAFLY", title: "Alphafly" },
//             { tag: "SPIKES", title: "Spikes" }
//           ]
//         },
//         "women-asics-running-shoes": {
//           title: "ASICS",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225",
//           types: []
//         },
//         //  "women-asics-running-shoes": {
//         //   title: "ASICS",
//         //   image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/asics-63985.svg?v=1779282225",
//         //   types: []
//         // }
//       }
//     },

//     "women-casual-shoes": {
//       title: "Casual Shoes",
//       image: null,
//       brands: {
//         "women-adidas-casual-shoes": {
//           title: "Adidas",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/adidas-18.svg?v=1779282123",
//           types: [
//             { tag: "adidas gazelle", title: "Gazelle" },
//             { tag: "ADIDAS CAMPUS", title: "Campus" },
//             { tag: "adidas superstar", title: "Superstar" }
//           ]
//         },
//         "women-new-balance-casual-shoes": {
//           title: "New Balance",
//           image: "https://cdn.shopify.com/s/files/1/0769/3526/6597/files/newbalnce.png?v=1779386719",
//           types: []
//         }
//       }
//     }

//   }

// };